module.exports = __webpack_public_path__ + "static/img/icon-hotel-type3.50650943.png";